import * as React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { useTeams } from 'msteams-react-base-component';
import { useEffect } from 'react';

export const TabConfig: React.FC = () => {

    const [{ inTeams, theme, context }] = useTeams();

    const onSaveHandler = (saveEvent: microsoftTeams.settings.SaveEvent) => {
        if (context) {
            const host = "https://" + window.location.host;
            microsoftTeams.settings.setSettings({
                contentUrl: host + "/#/innovation/",
                websiteUrl: host + "/#/innovation/",
                suggestedDisplayName: "PreXLR innovation",
                // removeUrl: host + "/canvasTab/remove.html?theme={theme}",
                entityId: context.groupId ? context.groupId : "-"
            });
            saveEvent.notifySuccess();
        } else {
            saveEvent.notifyFailure();
        }
    };

    useEffect(() => {
        if (inTeams === true) {
            microsoftTeams.authentication.getAuthToken({
                successCallback: (token: string) => {
                    console.log(token);
                    // const decoded: { [key: string]: any; } = jwtDecode(token) as { [key: string]: any; };
                    // setName(decoded!.name);
                    //   microsoftTeams.appInitialization.notifySuccess();
                    microsoftTeams.settings.registerOnSaveHandler(onSaveHandler);
                    microsoftTeams.settings.setValidityState(true);
                },
                failureCallback: (message: string) => {
                    // setError(message);
                    microsoftTeams.appInitialization.notifyFailure({
                        reason: microsoftTeams.appInitialization.FailedReason.AuthFailed,
                        message
                    });
                },
                resources: [process.env.CANVAS_APP_URI as string]
            });
        } else {
            // setEntityId("Not in Microsoft Teams");
            microsoftTeams.appInitialization.notifyFailure({
                reason: microsoftTeams.appInitialization.FailedReason.Other
                // "Not in Microsoft Teams"
            });
        }
    }, [inTeams]);

    // microsoftTeams.settings.setValidityState(true);


    return (
        <div>

        </div>
    )


}